<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<mat-dialog-actions class="pull-right">
  <button mat-button mat-raised-button color="primary" mat-dialog-lose>Close</button>
</mat-dialog-actions>